export default "__VITE_ASSET__A5RzM7aH__"